import { Box, Button } from "@mui/material";
import Flex from "../../../../../components/Flex";
import StyledDialog from "../../../../../components/StyledDialog";
import Text from "../../../../../components/Text";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { getValueFromObj } from "../../../../../utils/utils";
import { formatDateTime } from "../../../../../utils/date-time-utility";

interface ReviewNoteModalProps {
  disclosureHost: DisclosureHost;
}

const ReviewNoteModal = ({ disclosureHost }: ReviewNoteModalProps) => {
  const task = disclosureHost.data ?? {};

  const reviewedBy =
    (task?.reviewedBy && getValueFromObj(task.reviewedBy)) ||
    (task?.assignTo && getValueFromObj(task.assignTo)) ||
    "-";

  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      dialogTitle={
        <Text fontWeight={"medium"} fontSize={"20px"}>
          Review Details
        </Text>
      }
      dialogAction={
        <Button variant="outlined" onClick={disclosureHost.close}>
          Close
        </Button>
      }
    >
      <Flex flexDirection={"column"} gap={2} width={"100%"} minWidth={"400px"}>
        <Box>
          <Text fontWeight={500} mb={0.5}>
            Reviewed By
          </Text>
          <Text>{reviewedBy}</Text>
        </Box>
        <Box>
          <Text fontWeight={500} mb={0.5}>
            Reviewed Date &amp; Time
          </Text>
          <Text>
            {task?.reviewedDate ? formatDateTime(task.reviewedDate) : "-"}
          </Text>
        </Box>
        <Box>
          <Text fontWeight={500} mb={0.5}>
            Review Notes
          </Text>
          <Text sx={{ whiteSpace: "pre-wrap" }}>
            {task?.reviewedNote || "-"}
          </Text>
        </Box>
      </Flex>
    </StyledDialog>
  );
};

export default ReviewNoteModal;
